import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getDairyManureStorage } from "services";

import { DEFAULT_CACHE_TIME, GET_DAIRY_MANURE_STORAGE } from "consts";

import { DairyManureStorage, WithInjectedName } from "models";

export const useGetDairyManureStorage = () => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("dairy", { useSuspense: false });

  return useQuery<Array<WithInjectedName<DairyManureStorage>>>({
    queryKey: [GET_DAIRY_MANURE_STORAGE],
    queryFn: async () => {
      const ManureStorage = await getDairyManureStorage();
      return ManureStorage.map((m) => ({ ...m, name: t(`storageTypes.${m.translationSlug}`) }));
    },
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
